import { Request } from '~src/httpClient/serverApi/requests/Request';

import { IImportPreview, IPreviewImportParams } from '../types/IBundleImport';

/**
 * The VizPortal `previewImport` Web Client method (CM `previewImport`): one page of what importing an
 * uploaded bundle would write to this site, with each item's disposition (created / overwritten).
 */
export class PreviewImportRequest extends Request<IPreviewImportParams, IImportPreview> {
  constructor(params: IPreviewImportParams) {
    super('previewImport', params);
  }
}
